module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 bg-lightest mb-4 pb-4"
  }, [_c('div', {
    staticClass: "px-5"
  }, [_c('div', {
    staticClass: "dark fs-super pt-4 pb-3"
  }, [_vm._v(_vm._s(_vm.niceDate(_vm.group.date)))]), _vm._v(" "), _c('table', {
    staticClass: "w-100"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.group.events), function(event) {
    return _c('tr', {
      key: event.id,
      staticClass: "fs-large"
    }, [_c('td', {
      staticClass: "fs-larger"
    }, [_vm._v(_vm._s(_vm.startHour(event.start)))]), _vm._v(" "), _c('td', {
      staticClass: "slightlySmallerText"
    }, [_vm._v(_vm._s(_vm.resources(event)))]), _vm._v(" "), _c('td', {
      staticClass: "slightlySmallerText"
    }, [_vm._v(_vm._s(_vm.hourToDuration(event.duration)))]), _vm._v(" "), _c('td', {
      staticClass: "slightlySmallerText"
    }, [_vm._v(_vm._s(event.notes))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "fs-largest"
    }, [_c('b', [_vm._v(_vm._s(event.quantityAvailable))]), _vm._v("/" + _vm._s(event.maximumLotation) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "fs-smaller"
    }, [_vm._v(_vm._s(event.maximumLotation - event.quantityAvailable) + " booked")])]), _vm._v(" "), (_vm.$route.meta.reschedule) ? _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn widest bg-color-2 border-color-2 fs-large my-2",
      attrs: {
        "disabled": _vm.getIsRescheduling
      },
      on: {
        "click": function($event) {
          return _vm.reschedulePrompt(event)
        }
      }
    }, [_vm._v(_vm._s(_vm.selectedEvent && _vm.selectedEvent.id == event.id && _vm.getIsRescheduling ? 'REBOOKING' : 'REBOOK'))])]) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.reschedule) ? _c('td', {
      staticClass: "text-center"
    }, [(event.status == -1) ? _c('button', {
      staticClass: "btn widest border-color-6 bg-color-6 lightest fs-large my-2",
      on: {
        "click": function($event) {
          return _vm.showCanceledPopup(event)
        }
      }
    }, [_vm._v("EVENT CANCELED")]) : _vm._e(), _vm._v(" "), (!_vm.canISellThisEvent(event)) ? _c('button', {
      staticClass: "btn widest border-color-6 bg-color-6 lightest fs-large my-2",
      on: {
        "click": function($event) {
          return _vm.showChannelClosedPopup(event)
        }
      }
    }, [_vm._v("Sales channel closed")]) : _c('button', {
      staticClass: "btn widest border-color-3 fs-large my-2",
      on: {
        "click": function($event) {
          return _vm.book(event)
        }
      }
    }, [_vm._v("BOOK")])]) : _vm._e()])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "bg-lighter dark bold"
  }, [_c('th', {
    staticClass: "startHourWidth"
  }, [_vm._v("Departure")]), _vm._v(" "), _c('th', [_vm._v("Resource")]), _vm._v(" "), _c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', {
    staticClass: "notesWidth"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Available/total")]), _vm._v(" "), _c('th')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-06c3ae34", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06c3ae34"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Availability/SingleDay.vue
// module id = 1760
// module chunks = 0